import { css } from "@emotion/react";
import { breakpoints, CSS_MQ, CSS_MQ_ONLY } from "../../../styles/breakpoints";

export const toggleableVisibility = css`
  display: none;

  &.visible-mobile {
    ${CSS_MQ.atMostSm} {
      display: block;
    }
  }

  &.visible-desktop {
    ${CSS_MQ.atLeastMd} {
      display: block;
    }
  }

  &.visible {
    display: block;
  }

  ${breakpoints.map(b => {
    return `&.visible-${b} {
    ${CSS_MQ_ONLY[b]} {
      display: block;
    }
  }`;
  })}
`;
